import { render, staticRenderFns } from "./sap-storeShare-add-or-update.vue?vue&type=template&id=b164f958&scoped=true"
import script from "./sap-storeShare-add-or-update.vue?vue&type=script&lang=js"
export * from "./sap-storeShare-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./sap-storeShare-add-or-update.vue?vue&type=style&index=0&id=b164f958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b164f958",
  null
  
)

export default component.exports